import { B64File } from 'common/classes/B64File.class';
import { SortieService } from 'sortie/store/service';
/**
 * Photos relatives à une sortie
 */
export class SortieImage {
    /**
     * Constructeur de l'objet Sortie
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d, _e;
        if (row) {
            this.idSortieImage = (_a = row.idSortieImage) !== null && _a !== void 0 ? _a : null;
            this.idSortie = (_b = row.idSortie) !== null && _b !== void 0 ? _b : null;
            this.file = (_c = row.file) !== null && _c !== void 0 ? _c : (row.url ? new B64File(B64File.pathUrlToFile(row.url)) : null);
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : null;
            this.saveDate = (_e = row.saveDate) !== null && _e !== void 0 ? _e : null;
        }
    }
    /**
     * Sauvegarde les images d'une sortie
     * @param sortieImages Images de la sortie
     * @return True si la sauvegarde a réussi, false sinon
     */
    static saveImages(sortieImages) {
        return SortieService.saveSortieImages(sortieImages);
    }
    /**
     * Suppression des images d'une sortie
     * @param sortieImages Images de la sortie à supprimer
     * @return True si la suppression a réussi, false sinon
     */
    static deleteImages(sortieImages) {
        return SortieService.deleteSortieImages(sortieImages);
    }
    /**
     * Utilisée pour envoyer les informations au back
     */
    toRaw() {
        var _a;
        return {
            idSortieImage: this.idSortieImage,
            idSortie: this.idSortie,
            file: this.file.toRaw(),
            actif: this.actif,
            saveDate: (_a = this.saveDate) !== null && _a !== void 0 ? _a : null,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU29ydGllSW1hZ2UuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJTb3J0aWVJbWFnZS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDdkQsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBSXJEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLFdBQVc7SUErQnZCOzs7T0FHRztJQUNILFlBQW1CLEdBQTBCOztRQUM1QyxJQUFJLEdBQUcsRUFBRTtZQUNSLElBQUksQ0FBQyxhQUFhLEdBQUcsTUFBQSxHQUFHLENBQUMsYUFBYSxtQ0FBSSxJQUFJLENBQUM7WUFDL0MsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFBLEdBQUcsQ0FBQyxRQUFRLG1DQUFJLElBQUksQ0FBQztZQUNyQyxJQUFJLENBQUMsSUFBSSxHQUFHLE1BQUEsR0FBRyxDQUFDLElBQUksbUNBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUN2RixJQUFJLENBQUMsS0FBSyxHQUFHLE1BQUEsR0FBRyxDQUFDLEtBQUssbUNBQUksSUFBSSxDQUFDO1lBQy9CLElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBQSxHQUFHLENBQUMsUUFBUSxtQ0FBSSxJQUFJLENBQUM7U0FDckM7SUFDRixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxVQUFVLENBQUMsWUFBMkI7UUFDbkQsT0FBTyxhQUFhLENBQUMsZ0JBQWdCLENBQUMsWUFBWSxDQUFDLENBQUM7SUFDckQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxNQUFNLENBQUMsWUFBWSxDQUFDLFlBQTJCO1FBQ3JELE9BQU8sYUFBYSxDQUFDLGtCQUFrQixDQUFDLFlBQVksQ0FBQyxDQUFDO0lBQ3ZELENBQUM7SUFFRDs7T0FFRztJQUNJLEtBQUs7O1FBQ1gsT0FBTztZQUNOLGFBQWEsRUFBRSxJQUFJLENBQUMsYUFBYTtZQUNqQyxRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7WUFDdkIsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ3ZCLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSztZQUNqQixRQUFRLEVBQUUsTUFBQSxJQUFJLENBQUMsUUFBUSxtQ0FBSSxJQUFJO1NBQy9CLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==